module.exports = __webpack_public_path__ + "img/pattern.56978639.png";